import buy_with_confidence from "../../../assets-user/home/buy_with_confidence.png";
import partner_for_growth from "../../../assets-user/home/partner_for_growth.png";
import sell_with_ease from "../../../assets-user/home/sell_with_ease.png";
import bgImg from "../../../assets-user/home/services_bg.png";

const OurService = () => {
  const services = [
    {
      img: buy_with_confidence,
      title: "Buy with Confidence.",
      description: [
        "Verified properties",
        "Smart filters",
        "Loan assistance",
        "Neighborhood insights",
      ],
    },
    {
      img: sell_with_ease,
      title: "Sell with Ease.",
      description: [
        "Property valuation",
        "Premium listings",
        "Direct buyers",
        "Faster closures",
      ],
    },
    {
      img: partner_for_growth,
      title: "Partner for Growth.",
      description: [
        "Access to leads",
        "Builder partnerships",
        "Premium exposure",
        "Commission opportunities",
      ],
    },
  ];

  return (
    <div>
      {/* Desktop View */}
      <div className="hidden lg:grid grid-cols-1 grid-rows-10 w-full px-4 sm:px-6 md:px-8 lg:px-10  bg-white pb-6">
        <div
          style={{
            backgroundImage: `url(${bgImg})`,
          }}
          className="row-span-7 py-36 xl:py-28 bg-cover rounded-t-3xl bg-no-repeat relative flex  justify-center items-center"
        >
          <div className="flex items-center w-[90%] mx-auto translate-y-full">
            <h2 className="text-lg sm:text-xl md:text-2xl  text-white">
              Explore Our Services
            </h2>
          </div>
          <div className="absolute translate-y-full w-[90%] mx-auto grid grid-cols-3 gap-4">
            {services?.map((service, i) => {
              return <ServiceCard service={service} key={i} />;
            })}
          </div>
        </div>
        <div className="row-span-3"></div>
      </div>
      {/* Mobile - Tab View */}
      <div className="lg:hidden grid grid-cols-1  grid-rows-10 w-full px-4 sm:px-6 md:px-8 lg:px-10  bg-white ">
        <div
          style={{
            backgroundImage: `url(${bgImg})`,
          }}
          className="row-span-7 py-32 sm:py-36 bg-cover bg-no-repeat relative flex  justify-center items-center rounded-t-3xl "
        >
          <div className="flex items-center w-[90%] mx-auto -translate-y-full ">
            <h2 className="text-lg sm:text-xl md:text-2xl  text-white">
              Explore Our Services
            </h2>
          </div>
          <div className="absolute translate-y-1/2 w-[96%] sm:w-[90%] mx-auto grid grid-cols-3 gap-2 sm:gap-4">
            {services?.map((service, i) => {
              return <ServiceCard service={service} key={i} />;
            })}
          </div>
        </div>
        <div className="row-span-3"></div>
      </div>
    </div>
  );
};

const splitTitle = (title) => {
  const words = title.split(" ");
  const mid = Math.ceil(words.length / 2);
  return [words.slice(0, mid).join(" "), words.slice(mid).join(" ")];
};

const ServiceCard = ({ service }) => {
  const [line1, line2] = splitTitle(service.title);

  return (
    <div className="flex relative flex-col lg:flex-row bg-white items-center shadow-lg hover:shadow-2xl gap-3  border-gray-400  rounded-lg px-2 sm:px-3 lg:px-6 py-3 sm:py-5">
      <div className="absolute inset-1 md:inset-2 rounded-lg border border-dashed border-gray-400 pointer-events-none"></div>

      <img src={service.img} alt="" className="w-12 h-1w-12 sm:w-16 sm:h-16" />

      <div className="flex flex-col gap-1 sm:gap-3 items-start justify-center">
        {/* TITLE */}
        <h3 className="w-full text-xs sm:text-sm md:text-xl font-semibold text-gray-600 text-center md:text-left flex justify-center lg:justify-start">
          {/* Desktop (single line) */}
          <span className="hidden lg:inline">{service.title}</span>

          {/* Mobile (two lines) */}
          <span className="lg:hidden  flex flex-col items-center leading-tight">
            <span>{line1}</span>
            <span>{line2}</span>
          </span>
        </h3>

        {/* Description Desktop */}
        <p className="hidden lg:block text-[0.6rem] sm:text-xs tracking-wide text-text-secondary">
          {service.description.join(", ") + "."}
        </p>

        {/* Description Mobile */}
        <div className="container mx-auto pl-3">
          <ul className="list-disc  lg:hidden text-[0.6rem] sm:text-xs text-text-secondary space-y-1 ">
            {service.description.map((point, idx) => (
              <li key={idx}>{point}</li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OurService;
